import { Page } from "@/models"
import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import { MotivosDeCancelamentoServiceAdapter } from "./adapter/MotivosDeCancelamentoServiceAdapter"
import { MotivoCancelamento } from "@/models/MotivoCancelamento"

export class FindMotivosDeCancelamentoUseCase {
	@Inject('MotivosDeCancelamentoServiceAdapter')
	private motivosDeCancelamentoAdapter!: MotivosDeCancelamentoServiceAdapter

	findAll = async (params?: any, config?: AxiosRequestConfig): Promise<Page<MotivoCancelamento>> =>
		this.motivosDeCancelamentoAdapter.find(params, config)

	findById = async (id: string): Promise<MotivoCancelamento> =>
		this.motivosDeCancelamentoAdapter.findById(id)
}